import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { OverdueService, overdueSettingsParams } from '@services/overdue.service';
import { I18NextPipe } from 'angular-i18next';
import {
  AlertComponent,
  ButtonComponent,
  EnumHelper,
  MbsPopupType,
  ModalComponent,
  ModalFooterDirective,
  NumberComponent,
  RadioComponent,
  SelectComponent,
  ToastService
} from 'mbs-ui-kit';
import { unidentifiedErrorText } from 'mbs-ui-shared/src/lib/interceptors/error-handler.interceptor';
import { OverdueAfterSuccessPeriod } from 'mbs-ui-shared@models/backup/schedule-models';

@Component({
  selector: 'mbs-overdue-modal',
  imports: [
    ModalComponent,
    I18NextPipe,
    RadioComponent,
    FormsModule,
    NumberComponent,
    SelectComponent,
    AlertComponent,
    ButtonComponent,
    ModalFooterDirective
  ],
  templateUrl: './overdue-modal.component.html'
})
export class OverdueModalComponent implements OnInit {
  private overdueService = inject(OverdueService);
  private toastService = inject(ToastService);

  public readonly alertType = MbsPopupType;
  public isSelected = true;
  public selectedComputers: {
    selectedPlansCount: number;
    selectedComputers?: { [key: string]: { isAll: boolean; plans: string[] } };
  } = null;
  public filters: any;

  public loading = false;

  public noSuccessfulMoreThan = false;
  public amount = 7;
  public period: OverdueAfterSuccessPeriod = OverdueAfterSuccessPeriod['Day(s)'];

  public OverduePeriod = EnumHelper.EnumToSelectIndexesArray(OverdueAfterSuccessPeriod);

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  ngOnInit(): void {
    if (this.baseModal && this.baseModal.data) {
      this.isSelected = this.baseModal.data.isSelected;
      this.selectedComputers = this.baseModal.data.selectedComputers;
      if (!this.isSelected) this.filters = this.baseModal.data.filters;
    }
  }

  getParams(): overdueSettingsParams {
    const params: overdueSettingsParams = {
      overdueSettings: {
        enabled: this.noSuccessfulMoreThan,
        amount: this.amount,
        period: this.period
      }
    };
    if (this.isSelected) {
      params.planIds = [];
      Object.keys(this.selectedComputers.selectedComputers).forEach((key) => {
        this.selectedComputers.selectedComputers[key].plans.forEach((id) => params.planIds.push({ planId: id, computerHid: key }));
      });
    } else {
      params.filter = this.filters;
    }
    return params;
  }

  confirmClickHandler(): void {
    this.loading = true;
    const params: overdueSettingsParams = this.getParams();
    this.overdueService.overdueSettings(params, this.isSelected).subscribe(
      (data: { countToBeUpdated: number }) => {
        if (data) {
          this.showToast(data);
        }
        this.cancelClickHandler(data && !!data.countToBeUpdated);
      },
      (e) => {
        this.showToast(null, e);
        this.cancelClickHandler();
      }
    );
  }

  showToast(data: { countToBeUpdated: number }, error = null): void {
    const toast = {
      header: 'Success',
      content: data
        ? `${data.countToBeUpdated > 0 ? data.countToBeUpdated + ' plan(s)' : data.countToBeUpdated + ' plan'} will be updated`
        : '',
      type: MbsPopupType.success,
      delay: 5000
    };
    if (error) {
      toast.header = 'Error';
      toast.content = error.message ? error.message : unidentifiedErrorText;
      toast.type = MbsPopupType.danger;
    }
    this.toastService.toast(toast);
  }

  cancelClickHandler(isSuccess = false): void {
    this.loading = false;
    if (isSuccess) this.baseModal.save(true);
    else this.baseModal.close();
  }
}
